import { HIVEMIND_INELIGIBLE } from '../../constants/hivemind';

export function getExperimentDetails(url) {
  return window
    .fetch(url, { headers: { Accept: 'application/json' }, credentials: 'include' })
    .then(response => response.json())
    .catch(() => {
      return [];
    });
}

export async function fetchExperimentDetails(url, updateState, stateObj) {
  try {
    const result = await getExperimentDetails(url);
    updateState(prevState => ({
      [stateObj]: {
        ...prevState[stateObj],
        bucket: result.cohortId,
        data: result.data
      }
    }));
  } catch (err) {
    updateState(prevState => ({
      [stateObj]: {
        ...prevState[stateObj],
        error: err,
        bucket: HIVEMIND_INELIGIBLE
      }
    }));
    console.error('Error fetching experiment details:', err);
  } finally {
    updateState(prevState => ({
      [stateObj]: {
        ...prevState[stateObj],
        loading: false
      }
    }));
  }
}
